import { ServerConnector, ConfigService, toHttpRequest }  from '../../../';

export class ClickTrackingService {
    /**
     * Send a click event to the backend to register the click on a specific answerId
     */
    public static async registerCitationClick(answerId: string): Promise<void> {

        const urlPath = `/line/synapse/bot/${ConfigService.synapseBotId}/updatecitationclickcount/`;
        
        try {
            console.log(`Citation click registered for answerId: ${answerId}`);
            await toHttpRequest(ServerConnector.getBotServerConnectorInstance().post(urlPath, answerId));
        } catch (err) {
            console.error(`Failed to register citation click for answerId: ${answerId}`, err);
        }
    }
}